'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className"];
import PropTypes from 'prop-types';
import { cloneElement, Children } from 'react';
import { findDOMNode } from 'react-dom';
import DragHandle from 'UIComponents/draggable/UIDragHandle';
import { callIfPossible } from 'UIComponents/core/Functions';
import devLogger from 'react-utils/devLogger';
import { jsx as _jsx } from "react/jsx-runtime";
function wrapChildWithDragSource(child, connectDragSource) {
  const isStatelessComponent = typeof child.type === 'function' && !(child.type.prototype && child.type.prototype.render);
  if (isStatelessComponent) {
    const wrappedChild = /*#__PURE__*/_jsx("span", {
      children: child
    });
    devLogger.warn({
      message: `You are using a stateless component as a child for UIDragListHandle.
      Because of this it had to be wrapped with a <span /> in order to work with drag and drop.
      To remove the span, please make the child component a react class.`
    });
    return callIfPossible(connectDragSource, wrappedChild);
  }
  return /*#__PURE__*/cloneElement(child, {
    ref: instance => {
      // eslint-disable-next-line react/no-find-dom-node
      callIfPossible(connectDragSource, findDOMNode(instance));
      const {
        ref
      } = child;
      callIfPossible(ref, instance);
    }
  });
}
const UIDragListHandle = (props, {
  connectDragSource
}) => {
  const {
      children,
      className
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if (children) {
    return /*#__PURE__*/_jsx(DragHandle, Object.assign({
      className: className
    }, rest, {
      _wrappedWithDnd: true,
      children: wrapChildWithDragSource(Children.only(children), connectDragSource)
    }));
  }

  // Workaround to prevent error "Only native element nodes can now be passed to React DnD connectors"
  // when rendering a DragHandle with no children, specifically for UIExpandableSection #102
  const dragHandle = callIfPossible(connectDragSource, /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(DragHandle, Object.assign({
      className: className
    }, rest, {
      _wrappedWithDnd: true
    }))
  }));
  return dragHandle;
};
UIDragListHandle.displayName = DragHandle.displayName;
UIDragListHandle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  handleClassName: PropTypes.string
};
UIDragListHandle.contextTypes = {
  connectDragSource: PropTypes.func
};
export default UIDragListHandle;